/**
 * Fechas de las pantallas v3 (Favoritos, Alertas, Cobertura), siempre en hora de Chile: «1 oct 2026»,
 * «8 de octubre de 2026», «9:02», «hoy / ayer / el 6 oct». Los meses van escritos aquí y no con Intl, porque las
 * abreviaturas de Intl cambian entre navegadores («sept.», «sep»).
 */
const TZ = 'America/Santiago';
const MES_CORTO = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
const MES_LARGO = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

type Partes = { y: number; m: number; d: number };

/** Año, mes (1-12) y día. Una fecha sola («2026-10-01») se toma tal cual; un instante, en hora de Chile. */
function partes(value: string | Date): Partes | null {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    return { y, m, d };
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const [y, m, d] = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(date).split('-').map(Number);
  return { y, m, d };
}

const diasEntre = (a: Partes, b: Partes) => Math.round((Date.UTC(b.y, b.m - 1, b.d) - Date.UTC(a.y, a.m - 1, a.d)) / 86400000);

/** «1 oct 2026» */
export function fechaCorta(value: string | Date | null | undefined): string {
  const p = value ? partes(value) : null;
  return p ? `${p.d} ${MES_CORTO[p.m - 1]} ${p.y}` : '';
}

/** «8 de octubre de 2026» */
export function fechaLarga(value: string | Date | null | undefined): string {
  const p = value ? partes(value) : null;
  return p ? `${p.d} de ${MES_LARGO[p.m - 1]} de ${p.y}` : '';
}

/** «9:02» (hora de Chile) */
export function hora(value: string | Date | null | undefined): string {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('es-CL', { timeZone: TZ, hour: 'numeric', minute: '2-digit', hour12: false }).format(date);
}

/** «hoy», «ayer», «6 oct» o «6 oct 2025» si es de otro año. */
export function diaRelativo(value: string | Date | null | undefined, now: Date = new Date()): string {
  const p = value ? partes(value) : null;
  const hoy = partes(now);
  if (!p || !hoy) return '';
  const dif = diasEntre(p, hoy);
  if (dif === 0) return 'hoy';
  if (dif === 1) return 'ayer';
  return p.y === hoy.y ? `${p.d} ${MES_CORTO[p.m - 1]}` : `${p.d} ${MES_CORTO[p.m - 1]} ${p.y}`;
}

/** «guardado hoy», «guardado ayer», «guardado el 6 oct». */
export function guardado(value: string | null | undefined, now: Date = new Date()): string {
  const r = diaRelativo(value, now);
  if (!r) return '';
  return r === 'hoy' || r === 'ayer' ? `guardado ${r}` : `guardado el ${r}`;
}
